<template>
  <div
    v-show="visitedViews.some((tag) => tag.path !== '/index')"
    id="tags-view-container"
    class="tags-view-container"
  >
    <scroll-pane
      ref="scrollPaneRef"
      class="tags-view-wrapper"
      @scroll="handleScroll"
    >
      <!-- &&!tag.meta.noCache -->
      <router-link
        v-for="tag in visitedViews"
        v-show="tag.path != '/index'"
        :key="tag.path"
        :data-path="tag.path"
        :class="{ 'active': isActive(tag), 'has-icon': tagsIcon }"
        :to="{ path: tag.path ? tag.path : '', query: tag.query, fullPath: tag.fullPath ? tag.fullPath : '' }"
        class="tags-view-item"
        :style="activeStyle(tag)"
        @click="handleTagClick(tag)"
        @click.middle="!isAffix(tag) ? closeSelectedTag(tag) : ''"
        @contextmenu.prevent="openMenu(tag, $event)"
      >
        <svg-icon
          v-if="tagsIcon && tag.meta && tag.meta.icon && tag.meta.icon !== '#'"
          :icon-class="tag.meta.icon"
        />
        <span class="tags-view-item-title">{{ proxy.$t('menu.' + tag.name) }}</span>
        <span
          v-if="!isAffix(tag)"
          class="tags-view-close"
          @click.prevent.stop="closeSelectedTag(tag)"
        >
          <close
            class="el-icon-close"
          />
        </span>
      </router-link>
    </scroll-pane>
    <ul
      v-show="visible"
      :style="{ left: left + 'px', top: top + 'px' }"
      class="contextmenu"
    >
      <li @click="refreshSelectedTag(selectedTag)">
        <refresh-right style="width: 1em; height: 1em" /> 刷新页面
      </li>
      <li
        v-if="!isAffix(selectedTag)"
        @click="closeSelectedTag(selectedTag)"
      >
        <close style="width: 1em; height: 1em" /> 关闭当前
      </li>
      <li @click="closeOthersTags">
        <circle-close style="width: 1em; height: 1em" /> 关闭其他
      </li>
      <li
        v-if="!isFirstView()"
        @click="closeLeftTags"
      >
        <back style="width: 1em; height: 1em" /> 关闭左侧
      </li>
      <li
        v-if="!isLastView()"
        @click="closeRightTags"
      >
        <right style="width: 1em; height: 1em" /> 关闭右侧
      </li>
      <li @click="closeAllTags(selectedTag)">
        <circle-close style="width: 1em; height: 1em" /> 全部关闭
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import ScrollPane from './ScrollPane.vue';
import { getNormalPath } from '@/utils/ruoyi';
import { useSettingsStore } from '@/store/modules/settings';
import { usePermissionStore } from '@/store/modules/permission';
import { useTagsViewStore } from '@/store/modules/tagsView';
import { RouteRecordRaw, RouteLocationNormalized } from 'vue-router';
const visible = ref(false);
const top = ref(0);
const left = ref(0);
const selectedTag = ref<RouteLocationNormalized>();
const affixTags = ref<RouteLocationNormalized[]>([]);
const scrollPaneRef = ref<InstanceType<typeof ScrollPane>>();

const { proxy } = getCurrentInstance() as ComponentInternalInstance;
const route = useRoute();
const router = useRouter();

const visitedViews = computed(() => useTagsViewStore().getVisitedViews());
const routes = computed(() => usePermissionStore().getRoutes());
const tagsIcon = computed(() => useSettingsStore().tagsIcon);

watch(route, () => {
  addTags();
  moveToCurrentTag();
});
watch(visible, (value) => {
  if (value) {
    document.body.addEventListener('click', closeMenu);
  } else {
    document.body.removeEventListener('click', closeMenu);
  }
});

const isActive = (r: RouteLocationNormalized): boolean => {
  return r.path === route.path;
};
const handleTagClick = (tag) => {
  console.log('tab', tag.meta.noCache);
  if (!tag.meta.noCache) {
    usePermissionStore().visitedViewsRouter(tag);
  }
};
const activeStyle = (tag: RouteLocationNormalized) => {
  if (!isActive(tag)) return {};
  return {
    'background-color': 'var(--tags-view-active-bg)',
    'border-color': 'var(--tags-view-active-border-color)',
  };
};
const isAffix = (tag: RouteLocationNormalized) => {
  return tag?.meta && tag?.meta?.affix;
};
const isFirstView = () => {
  try {
    return selectedTag.value.fullPath === '/index' || selectedTag.value.fullPath === visitedViews.value[1].fullPath;
  } catch {
    return false;
  }
};
const isLastView = () => {
  try {
    return selectedTag.value.fullPath === '/index' || selectedTag.value.fullPath === visitedViews.value[visitedViews.value.length - 1].fullPath;
  } catch {
    return false;
  }
};
const filterAffixTags = (routes: RouteRecordRaw[], basePath = '') => {
  let tags: RouteLocationNormalized[] = [];

  routes.forEach((route) => {
    if (route.meta && route.meta.affix) {
      const tagPath = getNormalPath(`${basePath }/${ route.path}`);
      tags.push({
        hash: '',
        matched: [],
        params: undefined,
        query: undefined,
        redirectedFrom: undefined,
        fullPath: tagPath,
        path: tagPath,
        name: route.name as string,
        meta: { ...route.meta },
      });
    }
    if (route.children) {
      const tempTags = filterAffixTags(route.children, route.path);
      if (tempTags.length >= 1) {
        tags = [...tags, ...tempTags];
      }
    }
  });
  return tags;
};
const initTags = () => {
  const res = filterAffixTags(routes.value);
  affixTags.value = res;
  for (const tag of res) {
    // Must have tag name
    if (tag.name) {
      // console.log('initTags--------------',tag);
      // useTagsViewStore().addVisitedView(tag);
    }
  }
};
const addTags = () => {
  const { name } = route;
  if (route.query.title) {
    route.meta.title = route.query.title as string;
  }
  if (name) {
    useTagsViewStore().addView(route as any);
  }
};
const moveToCurrentTag = () => {
  nextTick(() => {
    for (const r of visitedViews.value) {
      if (r.path === route.path) {
        scrollPaneRef.value?.moveToTarget(r);
        // when query is different then update
        if (r.fullPath !== route.fullPath) {
          useTagsViewStore().updateVisitedView(route);
        }
      }
    }
  });
};
const refreshSelectedTag = (view: RouteLocationNormalized) => {
  proxy?.$tab.refreshPage(view);
  if (route.meta.link) {
    useTagsViewStore().delIframeView(route);
  }
};
const closeSelectedTag = (view: RouteLocationNormalized) => {
  proxy?.$tab.closePage(view).then(({ visitedViews }: any) => {
    if (isActive(view)) {
      toLastView(visitedViews, view);
    }
  });
};
const closeRightTags = () => {
  proxy?.$tab.closeRightPage(selectedTag.value).then((visitedViews: RouteLocationNormalized[]) => {
    if (!visitedViews.find((i: RouteLocationNormalized) => i.fullPath === route.fullPath)) {
      toLastView(visitedViews);
    }
  });
};
const closeLeftTags = () => {
  proxy?.$tab.closeLeftPage(selectedTag.value).then((visitedViews: RouteLocationNormalized[]) => {
    if (!visitedViews.find((i: RouteLocationNormalized) => i.fullPath === route.fullPath)) {
      toLastView(visitedViews);
    }
  });
};
const closeOthersTags = () => {
  router.push(selectedTag.value).catch(() => {});
  proxy?.$tab.closeOtherPage(selectedTag.value).then(() => {
    moveToCurrentTag();
  });
};
const closeAllTags = (view: RouteLocationNormalized) => {
  proxy?.$tab.closeAllPage().then(({ visitedViews }) => {
    if (affixTags.value.some((tag) => tag.path === route.path)) {
      return;
    }
    toLastView(visitedViews, view);
  });
};
const toLastView = (visitedViews: RouteLocationNormalized[], view?: RouteLocationNormalized) => {
  const latestView = visitedViews.slice(-1)[0];
  if (latestView) {
    router.push(latestView.fullPath as string);
  } else {
    // now the default is to redirect to the home page if there is no tags-view,
    // you can adjust it to your needs.
    if (view?.name === 'Dashboard') {
      // to reload home page
      router.replace({ path: `/redirect${ view?.fullPath}` });
    } else {
      router.push('/');
    }
  }
};
const openMenu = (tag: RouteLocationNormalized, e: MouseEvent) => {
  const menuMinWidth = 105;
  const el = proxy?.$el as HTMLElement;
  const rect = el.getBoundingClientRect();
  const maxLeft = el.offsetWidth - menuMinWidth;
  const l = e.clientX - rect.left + 15;

  left.value = l > maxLeft ? maxLeft : l;
  top.value = e.clientY - rect.top;
  visible.value = true;
  selectedTag.value = tag;
};
const closeMenu = () => {
  visible.value = false;
};
const handleScroll = () => {
  closeMenu();
};

onMounted(() => {
  initTags();
  addTags();
});
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 34px;
  width: 100%;
  position: relative;
  font-family: var(--el-font-family);
  --tags-view-item-bg: #e5e8f2;
  --tags-view-item-text: #666;
  --tags-view-item-hover-bg: #dce1ed;
  background: transparent;

  .tags-view-wrapper {
    .tags-view-item {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      vertical-align: top;
      position: relative;
      cursor: pointer;
      height: 30px;
      line-height: 22px;
      background-color: var(--tags-view-item-bg);
      border: 1px solid transparent;
      color: var(--tags-view-item-text);
      padding: 0 8px 0 10px;
      font-size: 14px;
      font-weight: 400;
      margin-inline-start: 4px;
      margin-top: 2px;
      border-radius: 4px;
      // 前景与背景立即切换，避免选中态过渡时出现低对比度闪烁。
      transition: none;

      &:hover {
        background-color: var(--tags-view-item-hover-bg);
        color: var(--el-text-color-primary);
      }
      &:focus-visible {
        outline: 2px solid var(--el-color-primary);
        outline-offset: -2px;
      }
      &:first-of-type {
        margin-inline-start: 0;
      }
      &:last-of-type {
        margin-inline-end: 4px;
      }
      &.active {
        background-color: var(--tags-view-active-bg);
        color: var(--el-color-white);
        border-color: var(--tags-view-active-border-color);
      }
    }
  }
  .tags-view-item-title {
    white-space: nowrap;
  }
  .tags-view-close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-inline-end: -4px;
    border-radius: 4px;
    color: inherit;

    &:hover {
      background: var(--el-fill-color-dark);
      color: var(--el-text-color-primary);
    }

    .el-icon-close {
      width: 12px;
      height: 12px;
    }
  }
  .tags-view-item.active .tags-view-close {
    color: inherit;

    &:hover {
      background: var(--el-color-primary-dark-2);
    }
  }
  .contextmenu {
    margin: 0;
    background: var(--el-bg-color);
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}

:global(html.dark .tags-view-container) {
  --tags-view-item-bg: var(--el-fill-color);
  --tags-view-item-text: var(--el-text-color-regular);
  --tags-view-item-hover-bg: var(--el-fill-color-dark);
}
</style>
